<script>
export default {
  components: {},
  created: () => {
    document.body.classList.add('authentication-bg')
    document.body.classList.add('authentication-bg-pattern')
  },
}
</script>

<template>
  <div>
    <div class="account-pages">
      <div>
        <slot />
      </div>
    </div>
    <!-- <footer class="footer footer-alt">
      {{ new Date().getFullYear() }} ©
      <a href class="text-muted">DORP</a>
    </footer> -->
  </div>
</template>

<style lang="scss">
.account-pages {
  background-image: url('../../assets/images/login_image.jpg');
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
}

body {
  padding-bottom: 0 !important;
}
</style>
